import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StressGroupComponent } from '../stress-group/stress-group.component';

@Component({
  selector: 'app-dialog-stress-group',
  templateUrl: './dialog-stress-group.component.html',
  styleUrls: ['./dialog-stress-group.component.css']
})
export class DialogStressGroupComponent {
  
    
  constructor(
    private  dialogRef:  MatDialogRef<StressGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string, buttonCancel: string }) { }
}
